import { Flex, NavigateButton } from '@/components';
import { TenantManagerResourceGuard } from '@/features/authentication/_components/TenantManagerResourceGuard';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { HeaderTab } from '../../_components/HeaderTab';
import { RolesTable } from '../_components/RolesPage';

export const RolesPage: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <HeaderTab
        type="roles"
        tabBarExtraContent={
          <Flex gap={8}>
            <TenantManagerResourceGuard onlyEdit>
              <NavigateButton path="new" text={t('create')} />
            </TenantManagerResourceGuard>
          </Flex>
        }
      />
      <RolesTable />
    </>
  );
};
